/**
 * Utility functions for query parameter manipulation
 */

/**
 * Extracts specific query parameters from a search string
 * @param search - The search string from location (e.g., "?uiEnv=dev&bffEnv=prod&other=value")
 * @param allowedParams - Array of parameter names to extract
 * @returns Filtered query string without the leading '?' (e.g., "uiEnv=dev&bffEnv=prod")
 */
export const extractParams = (search: string, allowedParams: string[]): string => {
    return search
        .substring(1) // Remove the '?' at the beginning
        .split('&')
        .filter((param: string) => {
            const [key] = param.split('=');
            return allowedParams.includes(key);
        })
        .join('&');
};

/**
 * Extracts environment and deal-related query parameters
 * @param search - The search string from location
 * @returns Filtered query string with uiEnv, bffEnv, and dealXgId parameters
 */
export const extractQueryParams = (search: string): string => {
    return extractParams(search, ['uiEnv', 'bffEnv', 'dealXgId']);
};
